const MAX_IMAGE_SIZE = 50 * 1024 * 1024; // 50MB
const MAX_VIDEO_SIZE = 100 * 1024 * 1024; // 100MB

const MAX_UPLOAD_IMAGES = 10; // Max images/videos per upload

const MAX_CHUNK_SIZE = 5 * 1024 * 1024; // 5MB per chunk (AWS S3 minimum)

const ACCEPTED_IMAGES = {
  'image/jpeg': [],
  'image/png': [],
  'image/heic': [],
  'image/jpg': [],
  'video/mp4': [],
  'video/quicktime': [],
};

const UPLOAD_TIMEOUT = 90 * 1000; // 90 seconds

const ACCEPTED_IMAGES_STRING = 'image/*, video/mp4, video/quicktime';

export {
  MAX_IMAGE_SIZE,
  MAX_UPLOAD_IMAGES,
  ACCEPTED_IMAGES,
  MAX_CHUNK_SIZE,
  MAX_VIDEO_SIZE,
  ACCEPTED_IMAGES_STRING,
  UPLOAD_TIMEOUT,
};

